<template lang="pug">
div.page-content
  app-modal-visualiza-pdf(
    v-if="modal"
    :titulo="titulo"
    @closeModal="fecharModal"
    :bytes="byte"
  )
  h1.titulo Legislações
  el-collapse(v-model="abaAtiva")
    el-collapse-item(title="LEGISLAÇÃO AMBIENTAL APLICADA À REGULARIZAÇÃO FUNDIÁRIA")
      li
        a(
          type="text"
          index='key'
          @click="visualizar('Constituição Estadual do Estado do Pará - Meio Ambiente.pdf')"
        ) Constituição Estadual do Estado do Pará - Meio Ambiente
      li
        a(
          type="text",
          index='key',
          @click="visualizar('Lei nº6.938 de 31 de agosto de 1981 (Dispõe sobre a Política Nacional do Meio Ambiente).pdf')"
        ) Lei nº6.938, de 31 de agosto de 1981 (Dispõe sobre a Política Nacional do Meio Ambiente)
      li
        a(
          type="text",
          index='key',
          @click="visualizar('Lei nº11.284 de 2 de março de 2006 (Lei de Gestão de Florestas Públicas).pdf')"
        ) Lei nº11.284, de 2 de março de 2006 (Lei de Gestão de Florestas Públicas)
      li
        a(
          type="text",
          index='key',
          @click="visualizar('Lei nº12.651 de 25 de maio de 2012 (Código Florestal).pdf')"
        ) Lei nº12.651, de 25 de maio de 2012 (Código Florestal)
      li
        a(
          type="text",
          index='key',
          @click="visualizar('Decreto Estadual nº1.148 de 17 de julho de 2008.pdf')"
        ) Decreto Estadual nº1.148, de 17 de julho de 2008 (Dispõe
          |  sobre o cadastro ambiental rural-CAR-PA, área de reserva legal e dá outras providências)
      li
        a(
          type="text",
          index='key',
          @click="visualizar('Decreto nº8.235 de 5 de maio de 2014.pdf')"
        ) Decreto nº8.235, de 5 de maio de 2014 (estabelece normas gerais
          |  complementares aos Programas de Regularização Ambiental dos Estados e do Distrito Federal - PRA)
      li
        a(
          type="text",
          index='key',
          @click="visualizar('Decreto Estadual nº1.379 de 3 de setembro de 2015.pdf')"
        ) Decreto Estadual nº1.379, de 3 de setembro de 2015 (cria
          |  o Programa de Regularização Ambiental dos Imóveis Rurais do Estado do Pará-PRA/PA e dá outras providências)

  el-collapse(v-model="abaAtiva")
    el-collapse-item(title="LEGISLAÇÃO FUNDIÁRIA ESTADUAL EM VIGOR")
      ul
        li
          h3 Atos da Corregedoria de Justiça do Estado do Pará referente aos registros de imóveis
        ul
          li
            a(
              type="text",
              index='key',
              @click="visualizar('Provimento 02-2010-Dispõe sobre a averbação de CANCELAMENTO das matrículas imobiliárias bloqueadas.pdf')"
            ) Provimento 02-2010-Dispõe sobre a averbação de CANCELAMENTO das matrículas imobiliárias bloqueadas
          li
            a(
              type="text",
              index='key',
              @click="visualizar('Provimento 10-2012- dispõe sobre o procedimento de REQUALIFICAÇÃO das matrículas imobiliárias.pdf')"
            ) Provimento 10-2012- dispõe sobre o procedimento de REQUALIFICAÇÃO das matrículas imobiliárias
          li
            a(
              type="text",
              index='key',
              @click="visualizar('Provimento 013-2006 - Dispõe sobre a averbação de BLOQUEIO de Matrículas de áreas rurais.pdf')"
            ) Provimento 013-2006 - Dispõe sobre a averbação de BLOQUEIO de Matrículas de áreas rurais nos
              |  Cartórios do Registro de Imóveis nas Comarcas do Interior e dá outras providências.
          li
            a(
              type="text",
              index='key',
              @click="visualizar('Pedido de Providência nº0001943-67.2009.2.00.0000 do CNJ.pdf')"
            ) Pedido de Providência nº0001943-67.2009.2.00.0000 do CNJ (Determinou o
              |  Cancelamento das Matrículas Imobiliárias do Estado do Pará)
        li
          h3 Demais atos normativos do Poder Executivo
        el-collapse(v-model="abaAtiva")
          el-collapse-item(title="Assentamentos")
            ul
              li(v-for="(file, key) in assentamentos")
                a(
                  type="text",
                  index='key',
                  @click="visualizar(file.nameServer)"
                ) {{ file.name }}
        el-collapse(v-model="abaAtiva")
          el-collapse-item(title="Quilombos")
            ul
              li(v-for="(file, key) in quilombos")
                a(
                  type="text",
                  index='key',
                  @click="visualizar(file.nameServer)"
                ) {{ file.name }}
        li
          h3 Instruções Normativas
          ul
            li(v-for="(file, key) in instrucoes")
              a(
                type="text",
                index='key',
                @click="visualizar(file.nameServer)"
              ) {{ file.name }}
        li
          a(
            type="text",
            index='key',
            @click="visualizar('Constituição do Estado do Pará- Agrário.pdf')"
          ) Constituição do Estado do Pará - Agrário
        li
          a(
            type="text",
            index='key',
            @click="visualizar('Constituição Federal - Agrário.pdf')"
          ) Constituição Federal - Agrário
        li
          a(
            type="text",
            index='key',
            @click="visualizar('Lei n° 8.972-2020(Regula o processo administrativo no âmbito da Administração Pública do Estado do Pará).pdf')"
          ) Lei n° 8.972-2020 (Regula o processo administrativo no âmbito da Administração Pública do Estado do Pará)
        li
          a(
            type="text",
            index='key',
            @click="visualizar('lei nº8.878-2019( Nova Lei de Terras do Estado do Pará).pdf')"
          ) lei nº8.878-2019 (Nova Lei de Terras do Estado do Pará)

  el-collapse(v-model="abaAtiva")
    el-collapse-item(title="LEGISLAÇÃO FUNDIÁRIA FEDERAL EM VIGOR")
      ul
        li(v-for="(file, key) in legislacaoFederal")
          a(
            type="text",
            index='key',
            @click="visualizar(file.nameServer)"
          ) {{ file.name }}
  el-collapse(v-model="abaAtiva")
    el-collapse-item(title="PERÍODO REPUBLICANO")
      ul
        li(v-for="(file, key) in periodoRepublicano")
          a(
            type="text",
            index='key',
            @click="visualizar(file.nameServer)"
          ) {{ file.name }}

</template>

<script>
import {mapActions} from 'vuex'
import AppModalVisualizaPdf from './AppModalVisualizarPdf'

export default {

  components: {
    AppModalVisualizaPdf
  },

  data () {
    return {
      abaAtiva: ['colapse'],
      modal: false,
      titulo: '',
      byte: null,
      assentamentos: [
        {
          nameServer: 'DECRETO nº1.731 de 17 DE JUNHO DE 2009 (Cria o PEAS PINDORAMA localziado no município de Tailândia).pdf',
          name: 'DECRETO n° 1.731, de 17 DE JUNHO DE 2009 (Cria o PEAS PINDORAMA localziado no município de Tailândia)'
        },
        {
          nameServer: 'Decreto n°1.732 de junho de 2009 (Cria o PEAS CAMPO DOURADO localizado em Rondon do Pará).pdf',
          name: 'Decreto n°1.732, de junho de 2009 (Cria o PEAS CAMPO DOURADO localizado em Rondon do Pará)'
        },
        {
          nameServer: 'DECRETO n° 1.734 de 17 DE JUNHO DE 2009 (Cria PEAS BORBA GATO no município de Tailândia).pdf',
          name: 'DECRETO n° 1.734, de 17 DE JUNHO DE 2009 (Cria PEAS BORBA GATO no município de Tailândia)'
        },
        {
          nameServer: 'DECRETO n° 1.735 DE 17 DE JUNHO DE 2009 (Cria o PEAS ITABIR localizado no município de Bujaru).pdf',
          name: 'DECRETO n° 1.735, DE 17 DE JUNHO DE 2009 (Cria o PEAS ITABIR, localizado no município de Bujaru)'
        },
        {
          nameServer: 'DECRETO n° 1.736  DE 17 DE JUNHO DE 2009 (cria o PEAS MOCAJUBA localizado no municío de Bujaru).pdf',
          name: 'DECRETO n° 1.736,  DE 17 DE JUNHO DE 2009 (cria o PEAS MOCAJUBA localizado no municío de Bujaru)'
        },
        {
          nameServer: 'DECRETO n° 1.737 DE 17 DE JUNHO DE 2009( cria o PEAS MAJARI localizado no município de Porto de Moz).pdf',
          name: 'DECRETO n° 1.737, DE 17 DE JUNHO DE 2009( cria o PEAS MAJARI localizado no município de Porto de Moz)'
        },
        {
          nameServer: 'DECRETO n° 1.738 DE 17 DE JUNHO DE 2009( cria o PEAX ARUÃ localizado no município de Santarém).pdf',
          name: 'DECRETO n° 1.738, DE 17 DE JUNHO DE 2009( cria o PEAX ARUÃ localizado no município de Santarém)'
        },
        {
          nameServer: 'DECRETO n° 1.739 DE 17 DE JUNHO DE 2009 ( cria o PEAX CAMUTÁ DO PUCURUÍ localizado no município de Gurupá).pdf',
          name: 'DECRETO n° 1.739, DE 17 DE JUNHO DE 2009 ( cria o PEAX CAMUTÁ DO PUCURUÍ localizado no município de Gurupá)'
        },
        {
          nameServer: 'DECRETO n° 1.740 de 17 DE JUNHO DE 2009( cria o PEAX VISTA ELGRE localizado no município de Santarém).pdf',
          name: 'DECRETO n° 1.740, de 17 DE JUNHO DE 2009( cria o PEAX VISTA ELGRE localizado no município de Santarém)'
        },
        {
          nameServer: 'DECRETO n° 1.782 DE 20 DE JUNHO DE 2017( cria o PEAX ASSIMPEX localizado no município de Portel).pdf',
          name: 'DECRETO n° 1.782, DE 20 DE JUNHO DE 2017( cria o PEAX ASSIMPEX localizado no município de Portel)'
        },
        {
          nameServer: 'DECRETO n° 1.893 DE 10 DE NOVEMBRO DE 2017( cria PEAX ACANGATÁ localizado no município de Portel).pdf',
          name: 'DECRETO n° 1.893, DE 10 DE NOVEMBRO DE 2017( cria PEAX ACANGATÁ localizado no município de Portel)'
        },
        {
          nameServer: 'DECRETO n° 1.943 DE 06 DE OUTUBRO DE 2009( cria o PEAS ITAPEVAS localizado no município de Bujaru).pdf',
          name: 'DECRETO n° 1.943, DE 06 DE OUTUBRO DE 2009( cria o PEAS ITAPEVAS localizado no município de Bujaru)'
        },
        {
          nameServer: 'DECRETO n° 1.967 DE 23 DE JANEIRO DE 2018( cria o PEAX MAMURU localizado no município de Juruti e Aveiro).pdf',
          name: 'DECRETO n° 1.967, DE 23 DE JANEIRO DE 2018( cria o PEAX MAMURU localizado no município de Juruti e Aveiro)'
        },
        {
          nameServer: 'DECRETO n° 2.012 DE 20 DE MARÇO DE 2018 ( cria o PEAX ACUTIPEREIRA localizado no município de Portel).pdf',
          name: 'DECRETO n° 2.012, DE 20 DE MARÇO DE 2018 ( cria o PEAX ACUTIPEREIRA localizado no município de Portel)'
        },
        {
          nameServer: 'DECRETO n° 256 DE 9 DE AGOSTO DE 2019( cria o PEAX JACAREPURU localizado no município de Portel).pdf',
          name: 'DECRETO n° 256, DE 9 DE AGOSTO DE 2019( cria o PEAX JACAREPURU localizado no município de Portel)'
        },
        {
          nameServer: 'DECRETO nº1.401 de 24 de setembro de 2015( retifica a criação do PEAX CURUMUCURI localizado no município de juruti).pdf',
          name: 'DECRETO nº1.401, de 24 de setembro de 2015( retifica a criação do PEAX CURUMUCURI localizado no município de juruti)'
        },
        {
          nameServer: 'DECRETO nº 1.427 DE 10 DE NOVEMBRO DE 2015 ( cria o PEAS NOVA ESPERANÇA localizado no município de Dom Eliseu).pdf',
          name: 'DECRETO nº 1.427, DE 10 DE NOVEMBRO DE 2015 ( cria o PEAS NOVA ESPERANÇA localizado no município de Dom Eliseu)'
        },
        {
          nameServer: 'DECRETO nº 1.783 de 20 de junho de 2017( cria o PEAS DEUS É FIEL localizado no município de Rondon do Parál).pdf',
          name: 'DECRETO nº 1.783, de 20 de junho de 2017( cria o PEAS DEUS É FIEL localizado no município de Rondon do Parál)'
        },
        {
          nameServer: 'DECRETO nº 1.784 DE 20 DE JUNHO DE 2017 ( cria o PEAS LOURIVAL SANTANA localizado no município de Eldorado dos Carajás).pdf',
          name: 'DECRETO nº 1.784, DE 20 DE JUNHO DE 2017 ( cria o PEAS LOURIVAL SANTANA localizado no município de Eldorado dos Carajás)'
        },
        {
          nameServer: 'DECRETO nº1.785 DE 20 DE JUNHO DE 2017 (cria o PEAS BACABAL GRANDE localizado no município de Bom Jesus do Tocantins).pdf',
          name: 'DECRETO nº1.785, DE 20 DE JUNHO DE 2017 (cria o PEAS BACABAL GRANDE localizado no município de Bom Jesus do Tocantins)'
        },
        {
          nameServer: 'DECRETO nº 1.894 DE 10 DE NOVEMBRO DE 2017 ( cria o PEAX CATAIANDEUA localizado no município de Abaetetuba).pdf',
          name: 'DECRETO nº 1.894, DE 10 DE NOVEMBRO DE 2017 ( cria o PEAX CATAIANDEUA localizado no município de Abaetetuba)'
        },
        {
          nameServer: 'DECRETO Nº257 DE 9 DE AGOSTO DE 2019 (cria o PEAX ALTO CAMARAPI localizado no município de Portel).pdf',
          name: 'DECRETO Nº257, DE 9 DE AGOSTO DE 2019 (cria o PEAX ALTO CAMARAPI localizado no município de Portel)'
        },
        {
          nameServer: 'DECRETO nº947 DE 14 DE JANEIRO DE 2014( cria PEAS ALTO BONITO II no município de Dom Eliseu).pdf',
          name: 'DECRETO nº947, DE 14 DE JANEIRO DE 2014( cria PEAS ALTO BONITO II no município de Dom Eliseu)'
        },
        {
          nameServer: 'PORTARIA CONJUNTA  ITERPAINCRA SR 30 n° 01 de 05 de fevereiro de 2010( cria o PEAX SAPUCÁ-TROMBETAS).pdf',
          name: 'PORTARIA CONJUNTA  ITERPAINCRA SR 30 n° 01, de 05 de fevereiro de 2010( cria o PEAX SAPUCÁ-TROMBETAS)'
        },
        {
          nameServer: 'PORTARIA ITERPA n° 116 DE 08 DE JANEIRO DE 2010( cria o PEAX VILA NOVA localizado no município de Prainha).pdf',
          name: 'PORTARIA ITERPA n° 116, DE 08 DE JANEIRO DE 2010( cria o PEAX VILA NOVA localizado no município de Prainha)'
        },
        {
          nameServer: 'PORTARIA ITERPA nº 0786 DE 20 DE ABRIL DE 2010 (cria o PEAX  MARIAZINHA ARACATI localizado no município de Santarém).pdf',
          name: 'PORTARIA ITERPA nº 0786, DE 20 DE ABRIL DE 2010 (cria o PEAX  MARIAZINHA ARACATI localizado no município de Santarém)'
        },
        {
          nameServer: 'PORTARIA ITERPA nº 0787 DE 20 DE ABRIL DE 2010 ( cria o PEAX PRESIDENTE PRUDENTE-MONTE SINAI localizado em Juruti).pdf',
          name: 'PORTARIA ITERPA nº 0787, DE 20 DE ABRIL DE 2010 ( cria o PEAX PRESIDENTE PRUDENTE-MONTE SINAI localizado em Juruti)'
        },
        {
          nameServer: 'PORTARIA ITERPA nº 0788 DE 20 DE ABRIL DE  2010 (cria o PEAS REPARTIMENTO localizado em santarém).pdf',
          name: 'PORTARIA ITERPA nº 0788, DE 20 DE ABRIL DE  2010 (cria o PEAS REPARTIMENTO localizado em santarém)'
        },
        {
          nameServer: 'Retificação da Portaria ITERPA nº 0787 de 20 de abril de 2010.pdf',
          name: 'Retificação da Portaria ITERPA nº 0787, de 20 de abril de 2010'
        }
      ],
      quilombos: [
        {
          nameServer: 'Portaria de criação do TEQ MURUTEUAZINHO.pdf',
          name: 'Portaria de criação do TEQ MURUTEUAZINHO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ COTOVELO.pdf',
          name: 'Portaria de criação do TEQ COTOVELO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ MOCAMBO.pdf',
          name: 'Portaria de criação do TEQ MOCAMBO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ 2º DISTRITO DE MOCAJUBA.pdf',
          name: 'Portaria de criação do TEQ 2º DISTRITO DE MOCAJUBA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ ABACATAL-AURÁ.pdf',
          name: 'Portaria de criação do TEQ ABACATAL/AURÁ;'
        },
        {
          nameServer: 'Portaria de criação do TEQ BAILIQUE.pdf',
          name: 'Portaria de criação do TEQ BAILIQUE;'
        },
        {
          nameServer: 'Portaria de criação do TEQ BOM JESUS DO CENTRO OURO.pdf',
          name: 'Portaria de criação do TEQ BOM JESUS DO CENTRO OURO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ BOM REMÉDIO.pdf',
          name: 'Portaria de criação do TEQ BOM REMÉDIO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ CAMIRANGA.pdf',
          name: 'Portaria de criação do TEQ CAMIRANGA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ CARANANDUBA.pdf',
          name: 'Portaria de criação do TEQ CARANANDUBA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ GUAJARÁ MIRI.pdf',
          name: 'Portaria de criação do TEQ GUAJARÁ MIRI;'
        },
        {
          nameServer: 'Portaria de criação do TEQ GURUPÁ.pdf',
          name: 'Portaria de criação do TEQ GURUPÁ;'
        },
        {
          nameServer: 'Portaria de criação do TEQ ITABOCA-QUATROP_BOCAS-E-CACOAL.pdf',
          name: 'Portaria de criação do TEQ ITABOCA-QUATRO/ BOCAS-E-CACOAL;'
        },
        {
          nameServer: 'Portaria de criação do TEQ OXALÁ DE JACUNDAY.pdf',
          name: 'Portaria de criação do TEQ OXALÁ DE JACUNDAY;'
        },
        {
          nameServer: 'Portaria de criação do TEQ JURUSSACA.pdf',
          name: 'Portaria de criação do TEQ JURUSSACA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ LARANJITUBA E ÁFRICA.pdf',
          name: 'Portaria de criação do TEQ LARANJITUBA E ÁFRICA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ MACAPAZINHO.pdf',
          name: 'Portaria de criação do TEQ MACAPAZINHO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ MARIA RIBEIRA.pdf',
          name: 'Portaria de criação do TEQ MARIA RIBEIRA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ MATIAS.pdf',
          name: 'Portaria de criação do TEQ MATIAS;'
        },
        {
          nameServer: 'portaria_menino_jesus.pdf',
          name: 'Portaria de criação do TEQ MENINO JESUS;'
        },
        {
          nameServer: 'Portaria de criação do TEQ MOJU MIRI.pdf',
          name: 'Portaria de criação do TEQ MOJU MIRI;'
        },
        {
          nameServer: 'Portaria de criação do TEQ  NOSSA SENHORA DA CONCEIÇÃO.pdf',
          name: 'Portaria de criação do TEQ  NOSSA SENHORA DA CONCEIÇÃO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ  NOSSA SENHORA DO LIVRAMENTO.pdf',
          name: 'Portaria de criação do TEQ  NOSSA SENHORA DO LIVRAMENTO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ  RAMAL DO PIRATUBA.pdf',
          name: 'Portaria de criação do TEQ  RAMAL DO PIRATUBA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ  PORTO ALEGRE.pdf',
          name: 'Portaria de criação do TEQ  PORTO ALEGRE;'
        },
        {
          nameServer: 'Portaria de criação do TEQ CASTANHALZINHO.pdf',
          name: 'Portaria de criação do TEQ  CASTANHALZINHO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ ESPIRÍTO SANTO.pdf',
          name: 'Portaria de criação do TEQ  ESPIRÍTO SANTO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ ILHA GRANDE DO CUPIJÓ.pdf',
          name: 'Portaria de criação do TEQ ILHA GRANDE DO CUPIJÓ;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SÍTIO BOSQUE.pdf',
          name: 'Portaria de criação do TEQ SÍTIO BOSQUE;'
        },
        {
          nameServer: 'Portaria de criação do TEQ TERRA DE LIBERDADE.pdf',
          name: 'Portaria de criação do TEQ TERRA DE LIBERDADE;'
        },
        {
          nameServer: 'Portaria de criação do TEQ CAETÉ.pdf',
          name: 'Portaria de criação do TEQ CAETÉ;'
        },
        {
          nameServer: 'ortaria de criação do TEQ OXOSSI RIBEIRA DO JAMBUAÇU.pdf',
          name: 'Portaria de criação do TEQ OXOSSI RIBEIRA DO JAMBUAÇU;'
        },
        {
          nameServer: 'Portaria de criação do TEQ MOCAMBO SANTA FÉ E SANTO ANTÔNIO.pdf',
          name: 'Portaria de criação do TEQ MOCAMBO SANTA FÉ E SANTO ANTÔNIO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SANTA LUZIA DO TRACUATEUA.pdf',
          name: 'Portaria de criação do TEQ SANTA LUZIA DO TRACUATEUA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SANTA MARIA DO MIRINDEUA.pdf',
          name: 'Portaria de criação do TEQ SANTA MARIA DO MIRINDEUA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SANTANA AXÉ DO BAIXO JAMBUAÇU.pdf',
          name: 'Portaria de criação do TEQ SANTANA AXÉ DO BAIXO JAMBUAÇU;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SANTA QUITÉRIA_ITANCOÃZINHO.pdf',
          name: 'Portaria de criação do TEQ SANTA QUITÉRIA/ITANCOÃZINHO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SANTA RITA DE BARREIRA.pdf',
          name: 'Portaria de criação do TEQ SANTA RITA DE BARREIRA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SANTO CRISTO.pdf',
          name: 'Portaria de criação do TEQ SANTO CRISTO;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SÃO JOSÉ DO ICATU.pdf',
          name: 'Portaria de criação do TEQ SÃO JOSÉ DO ICATU;'
        },
        {
          nameServer: 'Portaria de criação do TEQ SÃO MANOEL.pdf',
          name: 'Portaria de criação do TEQ SÃO MANOEL;'
        },
        {
          nameServer: 'Portaria de criação do TEQ CONGO DA VILA DO TRACUATEUA.pdf',
          name: 'Portaria de criação do TEQ CONGO DA VILA DO TRACUATEUA;'
        },
        {
          nameServer: 'Portaria de criação do TEQ TAMBAI-AÇU.pdf',
          name: 'Portaria de criação do TEQ TAMBAI-AÇU;'
        },
        {
          nameServer: 'Portaria de criação do TEQ TIPITINGA.pdf',
          name: 'Portaria de criação do TEQ TIPITINGA;'
        }
      ],
      instrucoes: [
        {
          nameServer: 'IN nº01-2017 (Regularização fundiária onerosa- compra).doc',
          name: 'IN nº01-2017 (Regularização fundiária onerosa- compra)'
        },
        {
          nameServer: 'IN nº02-2010 (Regularização fundiária não-onerosa- doação).pdf',
          name: 'IN nº02-2010 (Regularização fundiária não-onerosa- doação)'
        },
        {
          nameServer: 'IN nº02-2017 (Dispõe sobre Pedido de Informação).docx',
          name: 'IN nº02-2017 (Dispõe sobre Pedido de Informação)'
        },
        {
          nameServer: 'IN nº02-2018 (Retificação ou ratificação de título dfinitivo E processo de expedição de Certidão).docx',
          name: 'IN nº02-2018 (Retificação ou ratificação de título dfinitivo E processo de expedição de Certidão)'
        },
        {
          nameServer: 'IN nº03-2010 (Dispõe sobre o processo de criação dos Projetos Estaduais de Assentamentos).doc',
          name: 'IN nº03-2010 (Dispõe sobre o processo de criação dos Projetos Estaduais de Assentamentos)'
        },
        {
          nameServer: 'IN nº04-2010 (Fixa o procedimento legal para o resgate administrativo ou administrativo especial dos títulos de aforamento).doc',
          name: 'IN nº04-2010 (Fixa o procedimento legal para o resgate administrativo ou administrativo especial dos títulos de aforamento)'
        },
        {
          nameServer: 'IN nº06-2010 (Fixa procedimento legal para permuta de áreas).doc',
          name: 'IN nº06-2010 (Fixa procedimento legal para permuta de áreas)'
        }
      ],
      legislacaoFederal: [
        {
          nameServer: 'Constituição Federal - Agrário.pdf',
          name: 'Constituição Federal - Agrário'
        },
        {
          nameServer: 'Lei nº4.504 de 30 de novembro de 1964 (Estatuto da Terra).pdf',
          name: 'Lei nº4.504, de 30 de novembro de 1964 (Estatuto da Terra)'
        },
        {
          nameServer: 'Lei nº 6.015 de 31 de dezembro de 1973 (Dispõe sobre os registros públicos e dá outras providências).pdf',
          name: 'Lei nº 6.015, de 31 de dezembro de 1973 (Dispõe sobre os registros públicos, e dá outras providências)'
        },
        {
          nameServer: 'Lei nº6.383 de 7 de dezembro de 1976 (Dispõe sobre o processo discriminatório de terras devolutas da União e dá outras providências).pdf',
          name: 'Lei nº6.383, de 7 de dezembro de 1976 (Dispõe sobre o processo discriminatório de terras devolutas da União e dá outras providências)'
        },
        {
          nameServer: 'Lei nº 6.739 de 5 de dezembro de 1979 (Dispõe sobre a matrícula e o registro de imóveis rurais e dá outras providências).pdf',
          name: 'Lei nº 6.739, de 5 de dezembro de 1979 (Dispõe sobre a matrícula e o registro de imóveis rurais e dá outras providências)'
        },
        {
          nameServer: 'Lei nº6.766 de 19 de dezembro de 1979 (Dispõe sobre o Parcelamento do Solo Urbano e dá outras providências).pdf',
          name: 'Lei nº6.766, de 19 de dezembro de 1979 (Dispõe sobre o Parcelamento do Solo Urbano e dá outras providências)'
        },
        {
          nameServer: 'Lei nº8.629 de 25 de fevereiro de 1993 (Dispõe sobre a regulamentação dos dispositivos constitucionais relativos à reforma agrária previstos no Capítulo III Título VII da Constituição Federal).pdf',
          name: 'Lei nº8.629, de 25 de fevereiro de 1993 (Dispõe sobre a regulamentação dos dispositivos constitucionais relativos à reforma agrária, previstos no Capítulo III, Título VII, da Constituição Federal)'
        },
        {
          nameServer: 'Lei nº8.666 de 21 de junho de 1993 (Regulamenta o art. 37 inciso XXI da Constituição Federal institui normas para licitações e contratos da Administração Pública e dá outras providências).pdf',
          name: 'Lei nº8.666, de 21 de junho de 1993 (Regulamenta o art. 37, inciso XXI, da Constituição Federal, institui normas para licitações e contratos da Administração Pública e dá outras providências)'
        },
        {
          nameServer: 'Lei nº4.947-1996.pdf',
          name: 'Lei nº4.947, de 6 de abril de 1996 (Fixa Normas de Direito Agrário, Dispõe sobre o Sistema de Organização e Funcionamento do Instituto Brasileiro de Reforma Agrária, e dá outras Providências)'
        },
        {
          nameServer: 'Lei nº 10.267-2001.pdf',
          name: 'Lei nº 10.267, de 28 de agosto de 2001 (Estabeleceu o Certificado de Cadastro de Imóveis Rurais-CCIR)'
        },
        {
          nameServer: 'Decreto nº4.449-2002.pdf',
          name: 'Decreto nº4.449, de 30 de outubro de 2002 (Altera os prazos do georreferenciamento de imóveis rurais)'
        },
        {
          nameServer: 'Lei nº11.952-2009(Dispõe sobre regularização fundiária das ocupações incidentes em terras situadas em áreas da União ou do INCRA).pdf',
          name: 'Lei nº11.952, de 25 de junho de 2009 (Dispõe sobre regularização fundiária das ocupações incidentes em terras situadas em áreas da União ou do INCRA)'
        },
        {
          nameServer: 'Lei nº 13.001-2014.pdf',
          name: 'Lei nº 13.001, de 20 de junho de 2014(Dispõe sobre a liquidação de créditos concedidos aos assentados da reforma agrária; concede remissão nos casos em que especifica)'
        },
        {
          nameServer: 'Lei nº 13.340-2016.pdf',
          name: 'Lei nº 13.340, de 28 de setembro de 2016 (Autoriza a liquidação e a renegociação de dívidas de crédito rural;)'
        },
        {
          nameServer: 'Medida Provisória nº910-2019.pdf',
          name: 'Medida Provisória nº910, de 10 de dezembro de 2019 (Altera a Lei nº 11.952, de 25 de junho de 2009, que dispõe sobre a regularização fundiária das ocupações incidentes em terras situadas em áreas da União)'
        }
      ],
      periodoRepublicano: [
        {
          nameServer: 'Decreto-Lei n°57 de 22 de agosto de 1969 (Dispõe sobre as terras públicas do Estado e dá outras providências- REVOGADO).pdf',
          name: 'Decreto-Lei n°57 de 22 de agosto de 1969 (Dispõe sobre as terras públicas do Estado e dá outras providências- REVOGADO)'
        },
        {
          nameServer: 'Decreto n°7.454 de 19 de fevereiro de 1971 (Regulamenta o decreto-lei n° 57-69- REVOGADO).pdf',
          name: 'Decreto n°7.454, de 19 de fevereiro de 1971 (Regulamenta o decreto-lei n° 57/69- REVOGADO)'
        },

        {
          nameServer: 'Lei n° 4.584 de 08 de outubro de 1975 (Cria o Instituto de Terras do Pará - ITERPA extingue a Divisão de Terras da Secretaria de Agricultura).pdf',
          name: 'Lei n° 4.584, de 08 de outubro de 1975 (Cria o Instituto de Terras do Pará - ITERPA, extingue a Divisão de Terras da Secretaria de Agricultura)'
        },
        {
          nameServer: 'Decreto nº 3.190 de 06 de fevereiro de 1984 (Dispõe sobre a delegação de atribuições do Presidente do Instituto de Terras do Pará - ITERPA).pdf',
          name: 'Decreto nº 3.190, de 06 de fevereiro de 1984 (Dispõe sobre a delegação de atribuições do Presidente do Instituto de Terras do Pará - ITERPA)'
        },
        {
          nameServer: 'Lei nº 5.849 de 24 de junho de 1994 (Dispõe sobre a lei agrícola agrária e fundiária do Estado do Pará).pdf',
          name: 'Lei nº 5.849 de 24 de junho de 1994 (Dispõe sobre a lei agrícola agrária e fundiária do Estado do Pará)'
        },
        {
          nameServer: 'Decreto nº 1.054 de 14 de fevereiro de 1996( declara a caducidade dos registros de posse efetuados perante as repartições de terras do Estado cujas áreas não foram legitimadas).pdf',
          name: 'Decreto nº 1.054, de 14 de fevereiro de 1996( declara a caducidade dos registros de posse efetuados perante as repartições de terras do Estado, cujas áreas não foram legitimadas)'
        },
        {
          nameServer: 'Lei nº 6.614 de 5 de janeiro de 2004 (Dispõe sobre a cessão e permissão de uso de bens imóveis do Estado do Pará).pdf',
          name: 'Lei nº 6.614, de 5 de janeiro de 2004 (Dispõe sobre a cessão e permissão de uso de bens imóveis do Estado do Pará)'
        },
        {
          nameServer: 'Decreto nº 2.363 de 31 de julho de 2006 (Autoriza a Presidência do Instituto de Terras do Pará - ITERPA a conceder autorização nos casos de transferência de direitos enfitêuticos e recebimento de foros).pdf',
          name: 'Decreto nº 2.363, de 31 de julho de 2006 (Autoriza a Presidência do Instituto de Terras do Pará - ITERPA a conceder autorização nos casos de transferência de direitos enfitêuticos e recebimento de foros)'
        },
        {
          nameServer: 'Decreto nº 2.472 de 29 de setembro de 2006 (Autoriza a permuta de áreas do Projeto Trairão quando incidentes em faixa considerada pela União como imemorialmente indígena).pdf',
          name: 'Decreto nº 2.472, de 29 de setembro de 2006 (Autoriza a permuta de áreas do Projeto Trairão, quando incidentes em faixa considerada pela União como imemorialmente indígena)'
        },
        {
          nameServer: 'Decreto nº 62 de 14 de março de 2007 (Extingue a aplicação do regime de compra especial para os títulos de posse cujas áreas não foram regularizadas na forma do Decreto Estadual nº 1.054).pdf',
          name: 'Decreto nº 62, de 14 de março de 2007 (Extingue a aplicação do regime de compra especial para os títulos de posse cujas áreas não foram regularizadas na forma do Decreto Estadual nº 1.054)'
        },
        {
          nameServer: 'Decreto nº 63 de 14 de março de 2007 (Aprova o Regulamento Geral do Instituto de Terras do Pará - ITERPA).pdf',
          name: 'Decreto nº 63, de 14 de março de 2007 (Aprova o Regulamento Geral do Instituto de Terras do Pará - ITERPA)'
        },
        {
          nameServer: 'Decreto nº 913 de 16 de abril de 2008 (Incorpora imóvel rural à CDI-Pará).pdf',
          name: 'Decreto nº 913, de 16 de abril de 2008 (Incorpora imóvel rural à CDI-Pará)'
        },
        {
          nameServer: 'Decreto n.º 1.001 de 29 de maio de 2008 (Institui a Política Estadual de Desenvolvimento do Extrativismo no Pará).pdf',
          name: 'Decreto n.º 1.001, de 29 de maio de 2008 (Institui a Política Estadual de Desenvolvimento do Extrativismo no Pará)'
        },
        {
          nameServer: 'Decreto n°1.805 de 21 de junho de 2009 (Define procedimentos para o resgate de enfiteuses e a aplicação do regime de compra especial para os títulos de aforamento).pdf',
          name: 'Decreto n°1.805, de 21 de junho de 2009 (Define procedimentos para o resgate de enfiteuses e a aplicação do regime de compra especial para os títulos de aforamento)'
        },
        {
          nameServer: 'Lei n°7.289 de 24 de julho de 2009 (Antiga Lei de Terras do Estado do Pará-REVOGADO).pdf',
          name: 'Lei n°7.289, de 24 de julho de 2009 (Antiga Lei de Terras do Estado do Pará-REVOGADO)'
        },
        {
          nameServer: 'Decreto n°2.135 de 26 de fevereiro de 2010(Regulamenta a Lei nº 7.289-2009- REVOGADO).pdf',
          name: 'Decreto n°2.135, de 26 de fevereiro de 2010(Regulamenta a Lei nº 7.289/2009- REVOGADO)'
        },
        {
          nameServer: 'Decreto n°2.163 de 4 de março de 2010 (Altera o Decreto n° 1.805 de 21 de julho de 2009 que define procedimentos para o resgate de enfiteuses e a aplicação do regime de compra especial para os títulos de aforamento).pdf',
          name: 'Decreto n°2.163, de 4 de março de 2010 (Altera o Decreto n° 1.805, de 21 de julho de 2009, que define procedimentos para o resgate de enfiteuses e a aplicação do regime de compra especial para os títulos de aforamento)'
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      downloadArquivoEstatico: 'downloadPortal/downloadArquivoEstatico',
      visualizarPdf: 'downloadPortal/visualizarPdf'
    }),
    async visualizar (nome) {
      this.titulo = nome
      const result = await this.visualizarPdf(nome)
      this.byte = result
      this.modal = true
    },
    baixar (nameServer) {
      this.downloadArquivoEstatico(nameServer)
    },
    fecharModal () {
      this.modal = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/element-variables.scss';

a {
  font-size: 14px;
  color: #009f61;
  cursor: pointer;
  font-weight: 500;
}

.page-content, h3 {
  font-size: 1.2em;
}

.titulo {
  color: $--color-primary;
}

.collapse-container {
  padding: 20px 0;
}

/deep/ .el-collapse-item__header {
  color: #777377
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/ConsultaLegislacao.vue